import { format } from "timeago.js";

export default class Utils {
  static formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }

  static formatTimeAgo(time) {
    return format(time + " UTC");
  }

  static formatDateTime(time) {
    return new Date(time).toLocaleDateString(
      'en-us', {
        weekday: "long", year: "numeric", month: "long", day: "numeric",
        hour: "numeric", minute: "numeric", second: "numeric"
      }
    );
  }

  static formatCompactDateTime(time) {
    return new Date(time).toLocaleString('en-US', {
      year: "numeric", month: "short", day: "numeric",
      hour: "2-digit", minute: "2-digit", second: "2-digit"
    });
  }

  static formatTime(time) {
    return new Date(time).toLocaleTimeString(
      'en-us', {
        hour: "numeric", minute: "numeric", second: "numeric"
      }
    );
  }

  static currentTimeUtcIso() {
    return new Date().toISOString().slice(0, -1);
  }

  static deepCopy(obj) {
    return JSON.parse(JSON.stringify(obj));
  }

  static generateUniqueId() {
    return crypto.randomUUID();
  }
}
